import { normalizeLocale } from "../translate.js";
import { guideRoutesEn } from "./en.js";
import { guideRoutesNl } from "./nl.js";
import { GUIDE_ROUTES } from "./structure.js";

/** @type {Record<string, Record<string, import("./types.js").GuideRouteMeta>>} */
const META_BY_LOCALE = {
  nl: guideRoutesNl,
  en: guideRoutesEn,
};

export { GUIDE_ROUTES };

/**
 * @param {string} [locale]
 */
export function buildGuideLinks(locale) {
  const normalized = normalizeLocale(locale);
  const meta = META_BY_LOCALE[normalized] ?? guideRoutesNl;

  return GUIDE_ROUTES.map((route) => ({
    ...route,
    ...meta[route.pageId],
  }));
}

/**
 * @param {string} path
 * @param {string} [locale]
 */
export function getGuideByPath(path, locale) {
  const match = GUIDE_ROUTES.find(
    (route) => route.paths.nl === path || route.paths.en === path,
  );
  if (!match) {
    return null;
  }

  return buildGuideLinks(locale).find((guide) => guide.pageId === match.pageId) ?? null;
}

/**
 * @param {string} pageId
 * @param {import("../infoPages/types.js").InfoPagesCatalog} infoPages
 * @param {string} [locale]
 */
export function getGuidePage(pageId, infoPages, locale) {
  const guide = buildGuideLinks(locale).find((item) => item.pageId === pageId);
  if (!guide) return null;
  return { guide, page: infoPages?.[pageId] ?? null };
}
